import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.sync = this.sync.bind(this);
    this.element.addEventListener("change", this.sync);
    this.sync();
  }

  disconnect() {
    this.element.removeEventListener("change", this.sync);
  }

  sync() {
    const answer = this.element.querySelector("input[name='assessment_item_response[answer_index]']:checked");
    const confidence = this.element.querySelector("input[name='assessment_item_response[confidence]']:checked");
    const submitButton = this.element.querySelector("#submitButton");
    if (!submitButton) return;

    submitButton.disabled = !(answer && confidence);
  }
}
